import { Box } from '@mentimeter/ragnar-ui/box';
import type { ReactNode } from 'react';
import { CanvasAreaLayout } from './CanvasAreaLayout';

interface EditorLayoutProps {
  canvas: ReactNode;
  slidesOverview: ReactNode;
  sidebar: ReactNode;
}

export const EditorLayout = ({
  canvas,
  slidesOverview,
  sidebar,
}: EditorLayoutProps) => (
  <Box
    as="main"
    flex="1 1 auto"
    flexDirection="row"
    width="100%"
    height="100%"
    bg="surfaceSunken"
    alignItems="stretch"
  >
    {slidesOverview}
    <CanvasAreaLayout>{canvas}</CanvasAreaLayout>
    {sidebar}
  </Box>
);
